import React from 'react';

interface ICard {
  children?: React.ReactNode;
}

const Card = (props: ICard) => {
  return (
    <div className="card">
      <div className="card-header">Card Header</div>
      <div className="card-body">{props.children}</div>
      <div className="card-footer">Card Footer</div>
    </div>
  );
};

export default Card;
